<div #gmap style="height:100%;width:100%"></div>
<div
  *ngIf="isInfoWindowVisible"
></div>
